import { bindActionCreators } from 'redux';
import idx from 'idx';
import partial from 'lodash/partial';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
  previous, vote, setRating, setComment, toggleVoting, setVoteIndex
} from 'focus_groups/ducks/vote';
import { fetchGroup } from 'focus_groups/ducks/view_state';
import VoteBar from 'focus_groups/components/vote_bar';

export function mapStateToProps(state) {
  const voteState = idx(state, _ => _.project.focusGroups.vote);
  const index = voteState.currentRevisionIndex || 0;
  const revisions = idx(state, _ => _.project.focusGroups.viewState.currentGroup.revisions);
  const type = idx(state, _ => _.project.focusGroups.viewState.currentGroup.type);
  const revision = idx(revisions, _ => _[index]);

  return {
    ...revision,
    ...voteState,
    type,
    totalRevisions: revisions.length
  };
}

export function mapDispatchToProps(dispatch, { params }) {
  const { focusGroupId, participantKey, anonymousKey } = params;

  return bindActionCreators({
    previous,
    setRating,
    setComment,
    toggleVoting,
    setVoteIndex,
    vote: partial(vote, participantKey, focusGroupId),
    fetchGroup: partial(fetchGroup, focusGroupId, participantKey, anonymousKey)
  }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(VoteBar));



// WEBPACK FOOTER //
// ./focus_groups/containers/vote_bar.js